import React, { useState } from 'react'
import { FaRegCircleCheck } from 'react-icons/fa6'
import { BsFillQuestionCircleFill } from 'react-icons/bs'
import { Form1 } from '../../components/forms/form1.components'
import './preorder.styles.scss'

const STEPS = [
  {
    id: 1,
    title: 'Details',
    copy: 'Tell us who you are and what you want baked.',
  },
  {
    id: 2,
    title: 'Request sent',
    copy: 'We confirm by email or phone. No payment on this page.',
  },
]

const PreorderPage = () => {
  const [pageStatus, setPageStatus] = useState(0)

  return (
    <section className="book-v2">
      <div className="book-v2__glow book-v2__glow--a" aria-hidden="true" />
      <div className="book-v2__glow book-v2__glow--b" aria-hidden="true" />
      <div className="book-v2__mark" aria-hidden="true" />

      <div className="book-v2__inner">
        <div className="book-v2__intro">
          <p className="book-v2__eyebrow">Hold the date</p>
          <h1>
            <span className="book-v2__script">Book</span>
            <span className="book-v2__solid">your bake</span>
          </h1>
          <p className="book-v2__lead">
            Share your event details and cake wishlist. We&apos;ll confirm availability by phone or
            email. No checkout or card charge on this page.
          </p>
        </div>

        <div className="book-v2__layout">
          <aside className="book-v2__steps" aria-label="Booking steps">
            {STEPS.map((step) => {
              const done = pageStatus >= step.id
              return (
                <div
                  key={step.id}
                  className={`book-v2__step${done ? ' book-v2__step--done' : ''}`}
                >
                  <div className="book-v2__step-icon" aria-hidden="true">
                    {done ? (
                      <FaRegCircleCheck size={18} />
                    ) : (
                      <BsFillQuestionCircleFill size={18} />
                    )}
                  </div>
                  <div>
                    <p className="book-v2__step-kicker">Step {step.id}</p>
                    <h2>{step.title}</h2>
                    <p>{step.copy}</p>
                  </div>
                </div>
              )
            })}
          </aside>

          <div className="book-v2__panel">
            <div className="book-v2__panel-mark" aria-hidden="true" />
            <div className="book-v2__panel-body">
              <Form1 sendOrderStatus={setPageStatus} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PreorderPage
